// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___tAj_","col":"styles_col__K-hcP"};